module.exports = __webpack_public_path__ + "static/img/10bg_1.a32265f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/10bg_1.png
// module id = 616
// module chunks = 1